import React from 'react'
import { Input, TextArea, Select, FormConsumer } from './form/form'
import {
    AGENT,
    VENDOR_PARTNER,
    AGENT_COUNT_OPTIONS
} from "../constants/demoRequestsConstants";


const DemoStep2 = props => {
    return (
        <FormConsumer>
            {({ formState }) => (
                <div className="step content">
                    <div className="demo-header">Request a Demo</div>
                    <div className="form-group-2">
                        <Input
                            required
                            name="first_name"
                            placeholder={'First Name'}
                        />
                        <Input
                            required
                            name="last_name"
                            placeholder={'Last Name'}
                        />
                    </div>
                    <Input
                        required
                        name="company"
                        placeholder={'Company Name'}
                    />
                    {formState['chooseYourBusiness'] !== AGENT &&
                    formState['chooseYourBusiness'] !== VENDOR_PARTNER &&
                        <Select
                            name="agentCount"
                            required
                            options={AGENT_COUNT_OPTIONS}
                            placeholder={'Number of Agents'}
                        />
                    }

                    <Input
                        name="email"
                        type="email"
                        required
                        pattern="^([a-zA-Z0-9_\.\-])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$"
                        placeholder={'Email Address'}
                    />
                    <Select
                        name="home_state"
                        required
                        options={props.stateOptions}
                        placeholder={'State/Province'}
                    />

                    {formState['chooseYourBusiness'] !== AGENT &&
                    formState['chooseYourBusiness'] !== VENDOR_PARTNER &&
                        <Input
                            name="phone"
                            type="phone"
                            placeholder={'Phone Number (Optional)'}
                        />
                    }

                    <TextArea
                        name="message"
                        placeholder={'Message (optional)'}
                    />

                    <p className="google-terms">
                        This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                    </p>

                    <button
                        type="submit"
                        className={`button button-cta progress`}
                    >
                        Request A Demo
                    </button>
                </div>
            )}
        </FormConsumer>
    )
}

export default DemoStep2
